import { render, staticRenderFns } from "./SelectInputConfig.vue?vue&type=template&id=6ab82046&scoped=true"
import script from "./SelectInputConfig.vue?vue&type=script&lang=js"
export * from "./SelectInputConfig.vue?vue&type=script&lang=js"
import style0 from "./SelectInputConfig.vue?vue&type=style&index=0&id=6ab82046&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab82046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab82046')) {
      api.createRecord('6ab82046', component.options)
    } else {
      api.reload('6ab82046', component.options)
    }
    module.hot.accept("./SelectInputConfig.vue?vue&type=template&id=6ab82046&scoped=true", function () {
      api.rerender('6ab82046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/config/SelectInputConfig.vue"
export default component.exports